var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0605,
    cy: 18.4436,
    r: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5608 18.4434L32.0674 18.4434",
    stroke: "black",
    strokeWidth: 0.816666
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.4348 30.8176L27.9646 28.3474",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.5999 34.6753L23.2944 31.435",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0608 35.9434L18.0608 32.45",
    stroke: "black",
    strokeWidth: 0.816666
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.68652 30.8176L8.15671 28.3474",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.82861 24.9832L5.0689 23.6777",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05371 18.4434L0.560344 18.4434",
    stroke: "black",
    strokeWidth: 0.816666
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.15674 8.53931L5.68656 6.06912",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.8264 5.45166L11.521 2.21137",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0608 4.43652L18.0608 0.943156",
    stroke: "black",
    strokeWidth: 0.816666
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.9648 8.53931L30.435 6.06912",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.0522 13.2092L34.2925 11.9038",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.4641 34.6526L12.781 31.4169",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.85156 11.8467L5.08723 13.1635",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.3403 5.46997L24.6572 2.2343",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.0337 23.7229L34.2694 25.0397",
    stroke: "black",
    strokeWidth: 0.408333
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0608 10.549L11.7941 25.1697L18.061 21.3394L24.3271 25.1696L18.0608 10.549Z",
    fill: "#D5001C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.bb6d4f91575e71b72343ccb804933681.svg";
export { ForwardRef as ReactComponent };